import { PlanDetail } from '@types';
import { usePlans } from '../usePlans';
import { useUserInput } from '../useUserInput';

export const useSelectedPlan = (): PlanDetail | undefined => {
	const plans = usePlans();
	const { planId } = useUserInput();

	return plans && planId ? plans.find((plan) => plan.id === planId) : undefined;
};
